import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <div className="max-w-md text-center" data-testid="payment-cancel-page">
        <p className="overline">Beam Concierge</p>
        <h1 className="mt-5 serif text-4xl text-foreground">No worries.</h1>
        <p className="mt-4 text-muted-foreground leading-relaxed">
          Your payment wasn't completed and you haven't been charged. Whenever you're
          ready, your invitation link is still valid — or reach out and we'll assist.
        </p>
        <Link
          to="/"
          className="mt-8 inline-flex items-center gap-2 bg-secondary px-7 py-3.5 text-sm text-secondary-foreground hover:bg-[var(--gold)] transition-colors duration-400"
        >
          Return home
        </Link>
      </div>
    </div>
  );
}
